import { autobind } from 'core-decorators';
import { BaseController } from '@Controller';
import Middle from './middle/middle.vue';
import Left from './left.vue';
import LandFeature from '../components/LandFeature'; // 地块图形组件
import WaterRoad from '../components/WaterRoad';
import River from '../components/River';

@autobind
class MainController extends BaseController {
    constructor(MixMapModule) {
        super();
        this.MixMapModule = MixMapModule;
    }

    static getConfig() {
        return {};
    }

    static getVMConfig(config, self) {
        return {
            data() {
                return {
                    ...config,
                    waterList: [],
                    waterRangeList: [],
                    contentType: 1,
                };
            },
        };
    }

    static getInput() {
        return {
            map: {
                renderFun: 'renderMap',
            },
        };
    }

    static getOutput(self) {
        return {
            Left: {
                component: Left,
                attribute() {
                    return {
                        props: {
                            onWaterList: self._onWaterList,
                        },
                        on: {
                            treeChildreClick: (data) => {
                                let { latitude, longitude } = data;
                                if (latitude && longitude) {
                                    longitude = Number(longitude);
                                    latitude = Number(latitude);
                                    self.MixMapModule.toCenter([longitude, latitude]);
                                }
                                // 地图对应的地块闪烁
                                self.vm.$refs.LandFeature.selectFeatureById(data.id);
                            },
                        },
                    };
                },
            },
            Middle: {
                component: Middle,
                attribute() {
                    let attr = {
                        props: {
                            renderMap: self.renderMap,
                            waterList: self.vm.waterList,
                            type: self.vm.contentType,
                        },
                        on: {
                            changeContentType(val) {
                                // 地图模式、图册模式类型切换事件，val的值1 ：地图 val的值2 :图册
                                self.vm.contentType = val;
                            },
                        },
                    };
                    return attr;
                },
            },
            LandFeature: {
                component: LandFeature,
                attribute() {
                    return {
                        props: {
                            rangeData: self.vm.waterRangeList,
                            idKey: 'waterId',
                        },
                        ref: 'LandFeature',

                    };
                },
            },
            WaterRoad: {
                component: WaterRoad,
                attribute() {
                    return {
                        props: {
                            baseUrl: '',
                            params: {
                                FORMAT: 'image/png',
                                VERSION: '1.1.0',
                                LAYERS: 'gc.dzdt:水面',
                                exceptions: 'application/vnd.ogc.se_inimage',
                            },
                        },
                        ref: 'WaterRoad',
                    };
                },
            },
            River: {
                component: River,
                attribute() {
                    return {
                        props: {
                            baseUrl: '',
                            params: {
                                FORMAT: 'image/png',
                                VERSION: '1.1.0',
                                LAYERS: 'gc.dzdt:河流',
                                exceptions: 'application/vnd.ogc.se_inimage',
                            },
                        },
                        ref: 'River',
                    };
                },
            },
        };
    }

    _onWaterList(data) {
        this.vvm.waterList = data || [];
        let rangeList = [];
        data.forEach((item) => {
            let range = item.waterRange;
            if (range) {
                range = JSON.parse(range);
                range.forEach((rangeItem) => {
                    rangeItem.waterId = item.id;
                });
                rangeList = rangeList.concat(range);
            }
        });
        this.vm.waterRangeList = rangeList;
    }
}

export default MainController;
